import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	recommendedSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllBoards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllPlans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewMyOpenIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewIssuesReportedByMe: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recommendedSection: {
		id: 'command-palette-quick-search.common.recommended.recommended-section',
		defaultMessage: 'Recommended',
		description: 'Section title for Recommended commands',
	},
	viewAllIssues: {
		id: 'command-palette-quick-search.common.recommended.view-all-issues',
		defaultMessage: 'View all issues',
		description: 'Command palette command that links to issues search',
	},
	viewAllProjects: {
		id: 'command-palette-quick-search.common.recommended.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'Command palette command that links to projects',
	},
	viewAllBoards: {
		id: 'command-palette-quick-search.common.recommended.view-all-boards',
		defaultMessage: 'View all boards',
		description: 'Command palette command that links to boards',
	},
	viewAllFilters: {
		id: 'command-palette-quick-search.common.recommended.view-all-filters',
		defaultMessage: 'View all filters',
		description: 'Command palette command that links to filters',
	},
	viewAllPlans: {
		id: 'command-palette-quick-search.common.recommended.view-all-plans',
		defaultMessage: 'View all plans',
		description: 'Command palette command that links to plans',
	},
	viewAllIssuesIssueTermRefresh: {
		id: 'command-palette-quick-search.common.recommended.view-all-issues-issue-term-refresh',
		defaultMessage: 'View all work items',
		description: 'Command palette command that links to issues search',
	},
	viewAllProjectsGalaxia: {
		id: 'command-palette-quick-search.common.recommended.view-all-projects-galaxia',
		defaultMessage: 'View all spaces',
		description: 'Command palette command that links to projects',
	},
	viewMyOpenIssues: {
		id: 'command-palette-quick-search.common.recommended.view-my-open-issues',
		defaultMessage: 'View my open work items',
		description: 'Command that will navigate to the my open work items filter page',
	},
	viewIssuesReportedByMe: {
		id: 'command-palette-quick-search.common.recommended.view-issues-reported-by-me',
		defaultMessage: 'View work items reported by me',
		description: 'Command that will navigate to the work items filter page reported by the user',
	},
});
